var _path, _path2, _circle, _path3, _rect, _rect2, _rect3, _rect4, _line, _line2, _path4, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkBankAccount(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 54,
    viewBox: "0 0 200 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M181.784 21.5333V11.698C181.784 9.50132 180.911 7.39465 179.358 5.84139C177.804 4.28814 175.698 3.41553 173.501 3.41553C171.305 3.41553 169.198 4.28814 167.645 5.84139C166.091 7.39465 165.219 9.50132 165.219 11.698V21.5333",
    stroke: "#D8D7E3",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M185.094 21.5305H161.907C159.163 21.5305 156.938 23.7551 156.938 26.4993V44.718C156.938 47.4622 159.163 49.6868 161.907 49.6868H185.094C187.838 49.6868 190.063 47.4622 190.063 44.718V26.4993C190.063 23.7551 187.838 21.5305 185.094 21.5305Z",
    stroke: "#D8D7E3",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 173.5,
    cy: 33.0088,
    r: 3.25439,
    fill: "#D8D7E3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M171.292 34.9242C171.538 34.0656 172.322 33.4736 173.215 33.4736H173.785C174.677 33.4736 175.462 34.0656 175.708 34.9242L176.956 39.2926C177.321 40.5702 176.361 41.8421 175.033 41.8421H171.967C170.638 41.8421 169.679 40.5702 170.044 39.2926L171.292 34.9242Z",
    fill: "#D8D7E3"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 65,
    y: 33,
    width: 79,
    height: 2,
    rx: 1,
    fill: "url(#paint0_linear_3334_3672)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 15.5945,
    y: 24.3513,
    width: 5.2973,
    height: 18.4324,
    rx: 1,
    stroke: "#D8D7E3",
    strokeWidth: 2
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 30.1892,
    y: 24.3513,
    width: 5.2973,
    height: 18.4324,
    rx: 1,
    stroke: "#D8D7E3",
    strokeWidth: 2
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 44.7837,
    y: 24.3513,
    width: 5.2973,
    height: 18.4324,
    rx: 1,
    stroke: "#D8D7E3",
    strokeWidth: 2
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 8.29736,
    y1: 53,
    x2: 58.8379,
    y2: 53,
    stroke: "#D8D7E3",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 12.6755,
    y1: 47.1621,
    x2: 54.4593,
    y2: 47.1621,
    stroke: "#D8D7E3",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M33.4073 1.61111L55.4471 16.8807C56.2528 17.4389 55.8578 18.7027 54.8776 18.7027H10.7981C9.81788 18.7027 9.42286 17.4389 10.2286 16.8807L32.2683 1.61111C32.6109 1.37377 33.0648 1.37377 33.4073 1.61111Z",
    stroke: "#D8D7E3",
    strokeWidth: 2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3334_3672",
    x1: 63,
    y1: 33,
    x2: 148,
    y2: 33,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6841BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1BAFA"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkBankAccount);
export default __webpack_public_path__ + "static/media/link-bank-account.000b5bd6.svg";
export { ForwardRef as ReactComponent };